import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { CommunicationService } from 'src/app/core/services/communication.service';
import { Client, StatusEnum } from 'src/app/shared/models/clients/client';
import { User, UserRole } from 'src/app/shared/models/users/user';

@Component({
  selector: 'app-client-detail',
  templateUrl: './client-detail.component.html',
  styleUrls: ['./client-detail.component.scss']
})
export class ClientDetailComponent implements OnInit {
  client: Client;
  user: User;
  userRole = UserRole;
  constructor(private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private communicationService: CommunicationService,
    private authService: AuthService
  ) {
    this.route.data.subscribe(resolversData => {
      this.client = resolversData.client;
    });

    this.communicationService.changeEmitted$.subscribe(data => {
      this.client = data;
    })
  }

  ngOnInit(): void {
    this.user = this.authService.user;
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  showRejectReason() {
    return this.client.status == StatusEnum.Active && this.client.isApproved == false;
  }

}
